import { UtilitarioService } from "@app/services/utilitario.service";

export class Filtros {

    ParticipanteId: number;
    TipoData: string;
    DataInicial: string;
    DataFinal: string;
    UnidadeId: number;
    Observacao: string;
    ProcessoId: number;
    TipoDRId: number;
    TipoDeAcaoId: number;
    ContaId: number;


    constructor() {
        this.DataInicial = UtilitarioService.retornaDataAtualMaisDias(0);
        this.DataFinal = UtilitarioService.retornaDataAtualMaisDias(0);
    }

}
